import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import moment from "moment";
import Picker from "react-month-picker";
import "../toggleableButton/toggleableButton.scss";
import { ArrowIcon } from "../../assets/images/svg";
import { API_DATE_FORMAT } from "../../app_constants";

const MonthPicker = ({
  theme = "",
  calendarStartDate,
  calendarEndDate,
  startDate,
  endDate,
  updateDates,
  single = false
}) => {
  const [isVisible, setVisibility] = useState(false);
  const [currentRange, setCurrentRange] = useState(
    single
      ? { year: null, month: null }
      : { from: { year: null, month: null }, to: { year: null, month: null } }
  );

  const [years, setYears] = useState({
    min: { from: null, month: null },
    max: { from: null, month: null }
  });

  useEffect(() => {
    handleDates(calendarStartDate, calendarEndDate, "years");
    handleDates(startDate, endDate, "values");
  }, [startDate, endDate]);

  const getYearAndMonth = (date) => ({
    year: moment(date).get("year"),
    month: moment(date).get("month") + 1
  });

  let handleDates = (startDate, endDate, rangeType) => {
    let startYearAndMonth = getYearAndMonth(startDate);
    let endYearAndMonth = getYearAndMonth(endDate);

    if (rangeType === "values") {
      if (single) {
        setCurrentRange(startYearAndMonth);
      } else {
        setCurrentRange({ from: startYearAndMonth, to: endYearAndMonth });
      }
    } else if (rangeType === "years") {
      setYears({ min: startYearAndMonth, max: endYearAndMonth });
    }
  };

  let handleOnChange = (year, month, idx) => {
    if (single) {
      setCurrentRange({ year, month });
      publish({ year, month });
    } else {
      const newRange = { ...currentRange, [idx === 0 ? "from" : "to"]: { year, month } };
      setCurrentRange(newRange);
      publish(newRange);
    }
  };

  const makeText = (m, dateTo) => {
    if (!m || !m.year || !m.month) return "Invalid date";

    const selectedDate = `${m.year}-${String(m.month).padStart(2, "0")}-01`;

    if (dateTo) {
      const lastDayOfMonth = moment(selectedDate).endOf("month").format(API_DATE_FORMAT);
      return moment(calendarEndDate).isBefore(moment(lastDayOfMonth))
        ? calendarEndDate
        : lastDayOfMonth;
    }
    return selectedDate;
  };

  const viewComponent = (m) => {
    if (m && m.year && m.month) return PICKER_LANG.months[m.month - 1] + ", " + m.year;
    return "Invalid date";
  };

  const publish = (range = currentRange) => {
    setVisibility(false);
    if (single) {
      updateDates(makeText(range));
    } else {
      updateDates(makeText(range.from), makeText(range.to, true));
    }
  };

  const PICKER_LANG = {
    months: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
  };

  return (
    <Picker
      theme={theme}
      show={isVisible}
      years={years}
      value={currentRange}
      lang={PICKER_LANG}
      onChange={handleOnChange}
      onDismiss={() => setVisibility(false)}
    >
      <div
        className={`toggleable-button-root ${isVisible ? "focused" : ""}`}
        onClick={() => setVisibility(true)}
        role="button"
      >
        {viewComponent(single ? currentRange : currentRange.from)}
        {!single && (
          <>
            <ArrowIcon className="DateRangePickerInput_arrow_svg" />
            {viewComponent(currentRange.to)}
          </>
        )}
      </div>
    </Picker>
  );
};

MonthPicker.propTypes = {
  theme: PropTypes.string,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  calendarStartDate: PropTypes.string,
  calendarEndDate: PropTypes.string,
  updateDates: PropTypes.func
};
export default MonthPicker;
